export interface ICommand { }

export class CloneCorporateScenarioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.CloneCorporateScenarioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	SourceId: string
	Id: string
	CloneName: string

	constructor (workspaceId: number, strategyId: string, sourceId: string, id: string, cloneName: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.SourceId = sourceId
		this.Id = id
		this.CloneName = cloneName
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.CloneCorporateScenarioCommandV1, TCh.Domain.Quest'
	}

}

export class CreateCorporateScenarioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.CreateCorporateScenarioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	PlanningStartDate: any
	PlanningEndDate: any
	Denomination: any
	ApplyBenefitsConfidenceFactor: boolean
	BenefitsConfidenceDate: any | null
	PortfolioIds: any

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, planningStartDate: any, planningEndDate: any, denomination: any, applyBenefitsConfidenceFactor: boolean, benefitsConfidenceDate: any | null, portfolioIds: any)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.PlanningStartDate = planningStartDate
		this.PlanningEndDate = planningEndDate
		this.Denomination = denomination
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
		this.BenefitsConfidenceDate = benefitsConfidenceDate
		this.PortfolioIds = portfolioIds
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.CreateCorporateScenarioCommandV1, TCh.Domain.Quest'
	}

}

export class DeleteCorporateScenarioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.DeleteCorporateScenarioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string

	constructor (workspaceId: number, strategyId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.DeleteCorporateScenarioCommandV1, TCh.Domain.Quest'
	}

}

export class OptimizeCorporateScenarioScheduleCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.OptimizeCorporateScenarioScheduleCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	MinStartDate: any
	MaxStartDate: any

	constructor (workspaceId: number, strategyId: string, id: string, minStartDate: any, maxStartDate: any)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.MinStartDate = minStartDate
		this.MaxStartDate = maxStartDate
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.OptimizeCorporateScenarioScheduleCommandV1, TCh.Domain.Quest'
	}

}

export class SetPortfolioCapexLimitCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioCapexLimitCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	PortfolioId: string
	Limit: number | null

	constructor (workspaceId: number, strategyId: string, id: string, portfolioId: string, limit: number | null)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.PortfolioId = portfolioId
		this.Limit = limit
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioCapexLimitCommandV1, TCh.Domain.Quest'
	}

}

export class SetPortfolioExpensesLimitCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioExpensesLimitCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	PortfolioId: string
	Limit: number | null

	constructor (workspaceId: number, strategyId: string, id: string, portfolioId: string, limit: number | null)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.PortfolioId = portfolioId
		this.Limit = limit
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioExpensesLimitCommandV1, TCh.Domain.Quest'
	}

}

export class SetPortfolioOpexExpensesLimitCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioOpexExpensesLimitCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	PortfolioId: string
	Limit: number | null

	constructor (workspaceId: number, strategyId: string, id: string, portfolioId: string, limit: number | null)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.PortfolioId = portfolioId
		this.Limit = limit
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioOpexExpensesLimitCommandV1, TCh.Domain.Quest'
	}

}

export class SetPortfolioOpexLimitCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioOpexLimitCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	PortfolioId: string
	Limit: number | null

	constructor (workspaceId: number, strategyId: string, id: string, portfolioId: string, limit: number | null)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.PortfolioId = portfolioId
		this.Limit = limit
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioOpexLimitCommandV1, TCh.Domain.Quest'
	}

}

export class SetPortfolioOthexLimitCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioOthexLimitCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	PortfolioId: string
	Limit: number | null

	constructor (workspaceId: number, strategyId: string, id: string, portfolioId: string, limit: number | null)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.PortfolioId = portfolioId
		this.Limit = limit
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioOthexLimitCommandV1, TCh.Domain.Quest'
	}

}

export class SetPortfolioResourceAllocationCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioResourceAllocationCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	PortfolioId: string
	ResourceId: string
	Allocation: number | null

	constructor (workspaceId: number, strategyId: string, id: string, portfolioId: string, resourceId: string, allocation: number | null)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.PortfolioId = portfolioId
		this.ResourceId = resourceId
		this.Allocation = allocation
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioResourceAllocationCommandV1, TCh.Domain.Quest'
	}

}

export class SetPortfolioTotalCostLimitCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioTotalCostLimitCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	PortfolioId: string
	Limit: number | null

	constructor (workspaceId: number, strategyId: string, id: string, portfolioId: string, limit: number | null)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.PortfolioId = portfolioId
		this.Limit = limit
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.SetPortfolioTotalCostLimitCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateActivePortfolioScenarioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.UpdateActivePortfolioScenarioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	PortfolioId: string
	PortfolioScenarioId: string

	constructor (workspaceId: number, strategyId: string, id: string, portfolioId: string, portfolioScenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.PortfolioId = portfolioId
		this.PortfolioScenarioId = portfolioScenarioId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.UpdateActivePortfolioScenarioCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateCorporateScenarioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.CorporateScenarios.Commands.UpdateCorporateScenarioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	PlanningStartDate: any
	PlanningEndDate: any
	Denomination: any
	ApplyBenefitsConfidenceFactor: boolean
	BenefitsConfidenceDate: any | null
	PortfolioIds: any

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, planningStartDate: any, planningEndDate: any, denomination: any, applyBenefitsConfidenceFactor: boolean, benefitsConfidenceDate: any | null, portfolioIds: any)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.PlanningStartDate = planningStartDate
		this.PlanningEndDate = planningEndDate
		this.Denomination = denomination
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
		this.BenefitsConfidenceDate = benefitsConfidenceDate
		this.PortfolioIds = portfolioIds
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.CorporateScenarios.Commands.UpdateCorporateScenarioCommandV1, TCh.Domain.Quest'
	}

}

